import Image from 'next/image';
import { memo, useEffect, useState } from 'react';

const images = ["/img/Datareport.webp", "/img/Investment.webp", "/img/Investments.webp"];
const Carousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);
        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <div className="unique-carousel">
            {images.map((image, index) => (
                <Image
                    key={index}
                    src={image}
                    alt={`Slide ${index + 1}`}
                    width={600}
                    height={400}
                    className={`unique-carousel-image ${index === currentIndex ? 'unique-active' : ''}`}
                    unoptimized
                />
            ))}
        </div>
    );
}

export default memo(Carousel);
